import { render, staticRenderFns } from "./MultiFilePreView.vue?vue&type=template&id=3ffa7372&scoped=true"
import script from "./MultiFilePreView.vue?vue&type=script&lang=js"
export * from "./MultiFilePreView.vue?vue&type=script&lang=js"
import style0 from "./MultiFilePreView.vue?vue&type=style&index=0&id=3ffa7372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffa7372",
  null
  
)

export default component.exports